var mediaGallery = {
  is2026: function($slider) {
    var $gallery = $slider && $slider.length
      ? $slider.closest('.js-media-gallery')
      : $('.js-media-gallery');
    return $gallery.attr('data-pdp-gallery') === '2026' || document.body.classList.contains('update-2026');
  },

  slickOptions: function($slider) {
    var is2026 = this.is2026($slider);
    var options = {
      infinite: !is2026,
      arrows: false,
      dots: false,
      initialSlide: 0
    };

    if (is2026) {
      var $dots = $slider.closest('.js-media-gallery').find('.js-media-gallery-indicators');
      options.dots = true;
      options.dotsClass = 'media-gallery-indicators__list';
      options.customPaging = function(slider, i) {
        return '<button type="button" aria-label="Go to image ' + (i + 1) + '"></button>';
      };
      if ($dots.length) {
        options.appendDots = $dots;
      }
    }

    return options;
  },

  updateArrows: function($slider, slick) {
    if (!this.is2026($slider) || !$slider || !$slider.length) return;

    slick = slick || ($slider[0] && $slider[0].slick);
    if (!slick) return;

    var current = typeof slick.currentSlide === 'number' ? slick.currentSlide : 0;
    var count = slick.slideCount || 0;
    var $root = $slider.closest('.js-media-gallery');
    var $prev = $root.find('.slick-slide-arrow-prev');
    var $next = $root.find('.slick-slide-arrow-next');
    var atStart = count < 1 || current <= 0;
    var atEnd = count < 1 || current >= count - 1;

    $prev.toggleClass('is-inactive', atStart).attr('aria-disabled', atStart ? 'true' : 'false');
    $next.toggleClass('is-inactive', atEnd).attr('aria-disabled', atEnd ? 'true' : 'false');
  },

  bindSliderEvents: function($slider) {
    $slider.off('.pdp2026Gallery');
    $slider.on('afterChange.pdp2026Gallery reInit.pdp2026Gallery', function(event, slick) {
      mediaGallery.updateArrows($slider, slick);
    });
  },

  initSlider: function($slider) {
    if (!$slider || !$slider.length) return;

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    $slider.closest('.js-media-gallery').find('.js-media-gallery-indicators').empty();
    this.bindSliderEvents($slider);
    $slider.slick(this.slickOptions($slider));
    this.updateArrows($slider);
  },

  init: function() {
    var $slider = $('.js-media-gallery-slide');
    this.initSlider($slider);

    setTimeout(function() {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('slickGoTo', 0);
        mediaGallery.updateArrows($slider);
      }
    }, 100);

    $('.js-media-gallery-arrow button').on('click', function() {
      var $button = $(this);
      if ($button.hasClass('is-inactive') || $button.attr('aria-disabled') === 'true') return;

      var arrowType = $button.attr('data-type');
      $slider.slick(arrowType);
    });

    $('body').on('click', '.js-media-gallery-thumb', function() {
      var position = parseInt($(this).attr('data-media-position'));
      $slider.slick('slickGoTo', position);
    });
  }
};

$(document).ready(function() {
  mediaGallery.init();
});
